export default [

	// 行业
	{
		path: '/news/industry',
		name: 'industry',
		meta: {
			title: '行业资讯',
			title2: '行业资讯-华略未来科技',
		},
		component: () => import('views/news/industry/industry.vue'),
	},
	// 公司
	{
		path: '/news/company',
		name: 'company',
		meta: {
			title: '公司资讯',
			title2: '公司资讯-华略未来科技',
		},
		component: () => import('views/news/company/company.vue'),
	},
	// 详情
	{
		path: '/news/detail/:id.html',
		name: 'detail',
		meta: {
			title: '新闻详情',
			title2: '新闻详情-华略未来科技',
		},
		component: () => import('views/news/detail/detail.vue'),
	},
];

